import Head from "next/head";
import Grid from "@material-ui/core/Grid";
import Appbar from '../components/appBar';
import Footer from "../components/footer"; 
import WidgetWa from "../components/widgetWa"; 
import Paper from '@material-ui/core/Paper';
import Typography from '../components/typography';
import Avatar from '@material-ui/core/Avatar';
import Container from '@material-ui/core/Container'; 
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import useStyles from '../styles/servicesStyle';

export default function Servicios() {

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const classes  = useStyles();

  return (  
     <> 
      <Head>
        <title>Servicios</title>
        <link rel="icon" href="/favicon.ico" /> 
        <meta charSet="utf-8" />
        <meta itemProp="description" content="Conozca todos los servicios que CIDU tiene para ofrecerle a usted y su negocio."/>
        <link rel="canonical" href="https://cidu.com.co/servicios" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>  
      <Grid>
        <Appbar/>
        <Grid >
          <div className={classes.backgrounplans} /> 
          <Grid container  justify="center" alignItems="center" >

              <Grid item xs={11}>
                  <Paper elevation={8} className={classes.paperContent}>
                    <Container maxWidth='md' className={classes.containertittle}>
                      <Grid container
                          direction="column"
                          justify="space-between"
                          alignItems="center"
                          className={classes.gridtittle}>
                          <Grid item>
                            <Typography variant="h3" marked="center" align="center" component="h1" className={classes.tittleservicepage}>
                              SERVICIOS
                            </Typography>
                            <Typography variant="h5" align="center"  component="p"  className={classes.subtittleservicepage}>
                            Conozca todos los servicios que CIDU tiene para ofrecerle a usted y su negocio.
                            </Typography>
                          </Grid>
                          <Grid item>
                          <Avatar alt="Arrow" src={"/images/services/Arrow.svg"} className={classes.arrowicon}/>
                          </Grid>
                        </Grid>
                    </Container>

                    <Grid item container className={classes.ContainerServiceOne}>
                      <Container >
                        <Grid container  justify="center"  direction="column" className={classes.tab}>
                          <Typography variant={matches ? "h5" : "h4"} align="left"   className={classes.tittleservice}>
                          ACTIVIDAD VALUATORIA
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Cálculo y liquidación del efecto plusvalía.</li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Avalúo comercial y de renta de inmuebles urbanos y rurales. </li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Avalúo comercial y de renta de recursos naturales y suelos de protección. </li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Avalúo comercial y de renta de edificaciones de conservación arqueológica, monumentos históricos y bienes de interes cultural - BIC.</li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Avalúo de inmuebles especiales.</li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Avalúo de obras de infraestructura. </li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Avalúo comercial y para normas NIIF y NIC de maquinaria fija y mobil, equipos y equipos especiales.</li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Avalúo comercial y para normas NIIF y NIC de activos fijos y operacionales.</li>
                          </Typography>
                            <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Avalúo comercial y de renta de activos operacionales y establecimientos de comercio.</li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}> 
                          <li>Avalúo comercial de Intangibles e intangibles especiales. </li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Avalúo de semovientes y animales.</li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Valoración de siniestros. </li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li> Avalúo de áreas de cesión.</li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Avalúo de zonas comunes.</li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Avalúo de joyas, orfebrería y obras de arte.</li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Revisión y control de calidad de avalúos.</li>
                          </Typography>
                        </Grid>
                      </Container>
                    </Grid>

                    <Grid item container className={classes.ContainerServiceTwo}>
                      <Container > 
                        <Grid container  justify="center" direction="column" className={classes.tab}>
                          <Typography variant={matches ? "h5" : "h4"} align="left"   className={classes.tittleservice}>
                          DESARROLLO URBANO
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Formulación, revision y/o modificación de planes parciales.</li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Formulación, revision y/o modificación de planes de implantación o planes de regularización.</li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Licencias de urbanismo.</li>
                          </Typography>
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Licencias de construcción.</li>
                          </Typography>
                        </Grid>
                      </Container>
                    </Grid>

                    <Grid item container className={classes.ContainerServiceTree}>
                      <Container > 
                        <Grid container  justify="center" direction="column" className={classes.tab}>
                          <Typography variant={matches ? "h5" : "h4"} align="left"   className={classes.tittleservice}>
                          ASESORÍA INMOBILIARIA
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Estudio de normas urbanísticas y potenciales de desarrollos.</li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li> Asesoría en la localización y adquisición de propiedades.</li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Estudio de jurídico de inmuebles.</li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Levantamientos topográficos y arquitectónicos.</li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Cartografía digital y sistemas de información geográfica - SIG.</li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Estudio y asesoría catastral.</li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Asesoría en tramites catastrales (englobes, desenglobes, revisión de avalúos catastrales, 
                          declaración de impuesto predial).      </li>                               
                          </Typography> 
                        </Grid>
                      </Container>
                    </Grid>

                    <Grid item container className={classes.ContainerServiceFour}>
                      <Container > 
                        <Grid container  justify="center"  direction="column" className={classes.tab}> 
                          <Typography variant={matches ? "h5" : "h4"} align="left"   className={classes.tittleservice}>
                          ASESORÍA Y EJECUCIÓN DE INVENTARIOS
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Valoración de inventarios.</li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Levantamiento de inventario físico e identificación con código de barras. </li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Conciliación contable.</li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li> Asesoría integral para el manejo y administración de activos.</li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Manuales de procedimientos  para la administración de activos.</li>
                          </Typography> 
                        </Grid>
                      </Container>
                    </Grid>

                    <Grid item container className={classes.ContainerServiceFive}>
                      <Container > 
                        <Grid container  justify="center"  direction="column" className={classes.tab}> 
                          <Typography variant={matches ? "h5" : "h4"} align="left"   className={classes.tittleservice}>
                          DUE DILIGENCE INMOBILIARIO 
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Evaluación de los riesgos reales o  contingencias que presenta el inmueble a vender o adquirir.</li>  
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Seguridad jurídica en la venta y compra.</li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Análisis, investigación y valoración de los aspectos urbanísticos, legales, arquitectónicos, y 
                          tributarios relativos al inmueble objeto de venta y compra. </li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Verificación de la exactitud del avaluo u oferta en que se ha basado la decisión de 
                          comprar.</li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Determinación de posibles pasivos ocultos en el negocio.</li>
                          </Typography> 
                          <Typography variant="h6" align="left"   className={classes.itemservice}>
                          <li>Investigación del ámbito financiero y comercial.</li>
                          </Typography> 
                        </Grid>
                      </Container>
                    </Grid>

                    <Grid item container className={classes.ContainerServiceSix}>
                      <Container >  
                        <Grid container justify="center" direction="column">  
                          <Typography variant={matches ? "h5" : "h4"} align="left"   className={classes.tittleservice}>
                            LEVANTAMIENTO ARQUITECTÓNICO
                          </Typography> 

                          <Grid item
                          container
                          direction="row"
                          justify="space-evenly"
                          alignItems="stretch">

                            <Grid item
                                container
                                direction="column"
                                justify="space-between"
                                alignItems="center"  xs={12} md={6}
                                className={classes.normalmargin}>

                              <Grid item>
                                <Typography variant="h6" align="left"   className={classes.itemservicebold}>
                                Levantamiento 2D y 3D mediante tecnología de punta: 
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li>Camara Matterport Pro 2</li>
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservicebold}>
                                Características:
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li>Fotografías en resolución 4K para imprimir y usar en pantallas 4K.</li>
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li>Modelos 3D inmersivos que ayudan a documentar y colaborar con facilidad.</li>
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li>Experiencias de Realidad Virtual de vanguardia que asombraran a cualquier persona.</li>
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li>Planos de planta en 2D automatizados para reducir algún costo adicional (Medidas con 99% de exactitud).</li>
                                </Typography>                     
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li>Multimedia Matter Tags™ para incluir texto, videos, música y enlaces dentro de su espacio 3D.</li>
                                </Typography>
                              </Grid>
                            </Grid> 
                            <Grid item
                                container
                                direction="row"
                                justify="center"
                                alignItems="center" xs={12} md={4}> 
                                <img src={"/images/services/matteport.jpg"} alt="matteport"  className={classes.matteport} draggable= 'false'/> 
                            </Grid> 
                          </Grid> 
                        </Grid>
                      </Container>
                    </Grid> 
                      
                    <Grid item container className={classes.ContainerServiceSeven}>
                      <Container>  
                        <Grid container justify="center" direction="column"> 
                          <Grid item>
                            <Typography variant={matches ? "h5" : "h4"} align="left"   className={classes.tittleservice}>
                              DRONE
                            </Typography>
                          </Grid> 
                          <Grid item container direction="row" justify="space-evenly" alignItems="stretch"> 
                            <Grid item
                                container
                                direction="column"
                                justify="center"
                                alignItems="center" xs={12} md={5}> 
                                <img  src={"/images/services/dronMarca.png"} alt="dronMarca" className={classes.matteport} draggable= 'false'/>
                                <img  src={"/images/services/dron.jpg"} alt="dron" className={classes.matteport} draggable= 'false'/>
                            </Grid> 
                            <Grid item
                                container
                                direction="column"
                                justify="space-between"
                                alignItems="flex-start"  xs={12} md={5}>
                                
                              <Grid item>
                                <Typography variant="h6" align="left"   className={classes.itemservicebold}>
                                Características:
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li> <span className={classes.itemservicebold}>Segmento:</span> Profesional, Hobby, fotografía, seguimiento, vigilancia.</li>
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li><span className={classes.itemservicebold}>Tiempo de vuelo máximo: </span>31 minutos.</li>
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li><span className={classes.itemservicebold}>Sensores Anti obstáculos:</span>Omnidireccional Alcance máximo 12 KM.</li>
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li><span className={classes.itemservicebold}>Despegue y aterrizaje:</span>De forma automática.</li>
                                </Typography>                      
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li><span className={classes.itemservicebold}>Visualización de las imágenes:</span> En tiempo real.</li>
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li><span className={classes.itemservicebold}>Cámara:</span> 20 megapíxeles.</li>
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li><span className={classes.itemservicebold}> Video: </span>4K - captura mucha mayor luz logrando mejor calidad de imagen.</li>
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li><span className={classes.itemservicebold}>Sensor:</span> 1”.</li>
                                </Typography> 
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                <li><span className={classes.itemservicebold}>Lente:</span> Hasselblad (Utilizado en cámaras profesionales).</li>
                                </Typography>
                              </Grid>
                            </Grid> 
                          </Grid>
                        </Grid>
                      </Container>
                    </Grid>


                    <Grid item container className={classes.ContainerServiceEight}>
                      <Container> 
                        <Grid container justify="center" direction="column"> 
                          <Grid item>
                            <Typography variant={matches ? "h5" : "h4"} align="left" className={classes.tittleservice}>
                            PRODUCTOS 2D Y 3D
                            </Typography>
                          </Grid> 
                          <Grid item
                          container
                          direction="row"
                          justify="space-evenly"
                          alignItems="flex-end"
                          className={classes.marginproducts}>

                            <Grid item
                                container
                                direction="column"
                                justify="flex-end"
                                alignItems="center" xs={11} md={5}>
                              <img src={"/images/services/exterior3d.jpg"} alt="exterior" className={classes.matteport} draggable= 'false'/>
                              <Typography variant="h6" align="left"   className={classes.itemservice}>
                              Estructuras - Exterior en 3D
                              </Typography>
                            </Grid> 
                            <Grid item 
                                container
                                direction="column"
                                justify="flex-end"
                                alignItems="center" xs={11} md={5}>
                              <img src={"/images/services/interior3d.jpg"} alt="interior3d" className={classes.matteport} draggable= 'false'/>
                              <Typography variant="h6" align="left"   className={classes.itemservice}>
                              Estructuras - Interior en 3D
                              </Typography>
                            </Grid>  
                          </Grid>

                          <Grid item
                          container
                          direction="row"
                          justify="space-evenly"
                          alignItems="flex-end"
                          className={classes.marginproducts}> 
                            <Grid item 
                                container
                                direction="column"
                                justify="flex-end"
                                alignItems="center" xs={11} md={5}>
                                <img  src={"/images/services/interior2d.jpg"} alt="interior2d" className={classes.matteport} draggable= 'false'/>
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                Plantas - Interior en 2D
                                </Typography>
                            </Grid> 
                            <Grid item 
                                container
                                direction="column"
                                justify="flex-end"
                                alignItems="center" xs={11} md={5}>
                                <img  src={"/images/services/ortofotos.jpg"} alt="ortofotos" className={classes.matteport} draggable= 'false'/>
                                <Typography variant="h6" align="left"   className={classes.itemservice}>
                                Ortofotos
                                </Typography>
                            </Grid> 
                          </Grid>
                        </Grid>
                      </Container>
                    </Grid> 
                  </Paper>  
              </Grid>
          </Grid>
        </Grid>
        <Footer/>
      </Grid>
      <WidgetWa link={"https://wa.me/573014606980/?text=Hola%20CIDU,%20quiero%20contactarme%20con%20Ustedes!"}/>
    </>
  );
} 